import { getRouteApi } from '@tanstack/react-router';
import * as React from 'react';

import { CampaignAuditScreen } from '@/routes/admin/campaigns/campaign-audit-screen';

// =============================================================================
// campaign-audit-route.tsx — Adaptateur routeur de la page « Audit » campagne (LANE-E-CAMPAIGN-AUDIT).
// =============================================================================
// L'id de campagne est le path param d'URL (« /admin/campaigns/$campaignId/audit ») — ressource d'URL,
// cohérent avec le contrat API (campaignId server-set). Le RankAdminClient vient du contexte global (DÉFAUT
// = HTTP réel) : aucun provider local nécessaire. Le composant de présentation reste testable hors routeur.

const routeApi = getRouteApi('/admin/campaigns/$campaignId/audit');

export function CampaignAuditRoute(): React.JSX.Element {
  const { campaignId } = routeApi.useParams();

  return <CampaignAuditScreen campaignId={campaignId} />;
}
